<div class="flex h-full min-h-0 w-full flex-col overflow-y-auto scrollbar-transparent">
  <div class="shrink-0 p-4">
    <admin-creator-payment-details-checklist
      (loaded)="onDetailsLoaded($event)"
    />
  </div>

  @if (showBeneficiaryForm()) {
  <div class="shrink-0 border-t border-zinc-200 p-4 dark:border-zinc-800">
    <div class="space-y-4">
      <div>
        <h4 class="text-sm font-semibold text-primary">Link Airwallex beneficiary</h4>
        <p class="mt-1 text-xs text-secondary">
          <code class="text-primary">airwallexId</code> is missing. Validate bank details, then create the
          beneficiary (GodMode admin API).
        </p>
      </div>

      <form class="grid w-full max-w-3xl gap-4 sm:grid-cols-2" (submit)="$event.preventDefault(); runValidate()">
        <fieldset class="contents" [disabled]="actionLoading()">
          <div class="space-y-1">
            <label for="ben-entity-type" class="block text-sm font-medium text-primary">Entity type</label>
            <select
              id="ben-entity-type"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.entity_type"
              (change)="onBeneficiaryFieldChange()"
            >
              @for (opt of entityTypeOptions; track opt) {
              <option [value]="opt">{{ opt }}</option>
              }
            </select>
          </div>

          <div class="space-y-1">
            <label for="ben-country" class="block text-sm font-medium text-primary">Bank country / currency</label>
            <select
              id="ben-country"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [value]="beneficiaryModel().bankCountryPreset"
              (change)="onCountryPresetChange($any($event.target).value)"
            >
              @for (preset of countryPresets; track preset.bankCountryCode) {
              <option [value]="preset.bankCountryCode">{{ preset.label }}</option>
              }
            </select>
          </div>

          <div class="space-y-1 sm:col-span-2">
            <label for="ben-account-name" class="block text-sm font-medium text-primary">Account name</label>
            <input
              id="ben-account-name"
              type="text"
              autocomplete="off"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.account_name"
              (input)="onBeneficiaryFieldChange()"
            />
          </div>

          <div class="space-y-1 sm:col-span-2">
            <label for="ben-account-number" class="block text-sm font-medium text-primary">
              @if (isSwiftCountry()) {
                IBAN (account_number)
              } @else {
                Account number
              }
            </label>
            <input
              id="ben-account-number"
              type="text"
              autocomplete="off"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm font-mono text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.account_number"
              (input)="onBeneficiaryFieldChange()"
            />
          </div>

          @if (!isSwiftCountry()) {
          <div class="space-y-1">
            <label for="ben-routing-1" class="block text-sm font-medium text-primary">
              @if (isUsCountry()) {
                ABA routing number
              } @else {
                Sort code
              }
            </label>
            <input
              id="ben-routing-1"
              type="text"
              autocomplete="off"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm font-mono text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.account_routing_value1"
              (input)="onBeneficiaryFieldChange()"
            />
          </div>
          }

          @if (isSwiftCountry()) {
          <div class="space-y-1" [class.sm:col-span-2]="!isUsCountry()">
            <label for="ben-routing-2" class="block text-sm font-medium text-primary">BIC (account_routing_value2)</label>
            <input
              id="ben-routing-2"
              type="text"
              autocomplete="off"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm font-mono text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.account_routing_value2"
              (input)="onBeneficiaryFieldChange()"
            />
          </div>
          }

          @if (isUsCountry()) {
          <div class="space-y-1">
            <label for="ben-account-category" class="block text-sm font-medium text-primary">Account type</label>
            <select
              id="ben-account-category"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.bank_account_category"
              (change)="onBeneficiaryFieldChange()"
            >
              <option value="Checking">Checking</option>
              <option value="Savings">Savings</option>
            </select>
          </div>
          }

          @if (isUsCountry() || isSwiftCountry()) {
          <div class="space-y-1 sm:col-span-2">
            <p class="text-xs font-medium uppercase tracking-wide text-secondary">Address</p>
          </div>
          <div class="space-y-1 sm:col-span-2">
            <label for="ben-street" class="block text-sm font-medium text-primary">Street address</label>
            <input
              id="ben-street"
              type="text"
              autocomplete="off"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.street_address"
              (input)="onBeneficiaryFieldChange()"
            />
          </div>
          <div class="space-y-1">
            <label for="ben-city" class="block text-sm font-medium text-primary">City</label>
            <input
              id="ben-city"
              type="text"
              autocomplete="off"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.city"
              (input)="onBeneficiaryFieldChange()"
            />
          </div>
          <div class="space-y-1">
            <label for="ben-state" class="block text-sm font-medium text-primary">State / county</label>
            <input
              id="ben-state"
              type="text"
              autocomplete="off"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.state"
              (input)="onBeneficiaryFieldChange()"
            />
          </div>
          <div class="space-y-1 sm:col-span-2">
            <label for="ben-postcode" class="block text-sm font-medium text-primary">Postcode / Eircode</label>
            <input
              id="ben-postcode"
              type="text"
              autocomplete="off"
              class="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm text-primary shadow-sm dark:border-zinc-700 dark:bg-zinc-950"
              [formField]="beneficiaryForm.postcode"
              (input)="onBeneficiaryFieldChange()"
            />
          </div>
          }

          <div class="flex flex-wrap items-center gap-3 sm:col-span-2">
            <button
              type="submit"
              class="rounded-lg border border-zinc-300 bg-white px-4 py-2 text-sm font-medium text-primary shadow-sm hover:bg-zinc-50 disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-900 dark:hover:bg-zinc-800"
              [disabled]="actionLoading()"
            >
              @if (actionLoading()) {
                Validating…
              } @else {
                Validate with Airwallex
              }
            </button>

            @if (showCreateButton()) {
            <button
              type="button"
              class="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
              (click)="runCreate()"
              [disabled]="actionLoading()"
            >
              @if (actionLoading()) {
                Creating…
              } @else {
                Create beneficiary
              }
            </button>
            }
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  }
</div>
